module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-08-e47f7d8660075f0e70f6476f9668457b.svg";